<template>
  <main class="interview">
    <img class="close_icon" src="@/assets/close.svg" v-on:click="onClose()" />
    <div class="interview_contents">
      <div class="interview_contents__left">
        <div class="qa qa--top">
          <div class="qa__question">
            <div class="qa__question_icon">Q1</div>
            <div class="qa__question_title" v-on:click="pager.toggleDebug()">
              最もやりたいことを教えてください
            </div>
          </div>
          <div class="qa__answer">
            <div class="qa__answer_icon">A1</div>
            <div class="qa__answer_title">
              {{ getFirstAnswer() }}
            </div>
          </div>
        </div>

        <template v-for="(item, index) in page.entry?.getHistory()" :key="index">
          <div class="qa" v-if="index != 0" v-on:click="entrydelete(item.getId())" style="cursor: pointer;">
            <div class="qa__question">
              <div class="qa__question_icon">Q{{ index + 1 }}</div>
              <div class="qa__question_title" v-if="item.getPhase() == 'entry'">
                「{{ item.getTitle() }}」で他にやりたいことは？
              </div>
            </div>
            <div class="qa__answer">
              <div class="qa__answer_icon">A{{ index + 1 }}</div>
              <div class="qa__answer_title">
                {{ makeAnswerStringByHistory(item) }}
              </div>
            </div>
          </div>
        </template>

        <div class="qa">
          <div class="qa__question">
            <div class="qa__question_icon qa__question_icon--active">Q{{ page?.entry?.getQuestionNumber() }}</div>
            <div class="qa__question_title">
              「{{
                page.entry?.getQuestionTitle()
              }}」で他にやりたいことは？<span>（複数選択可）</span>
            </div>
          </div>
          <div class="qa__answer">
            <div class="qa__answer_icon" v-if="false">A1</div>
            <div class="qa__answer_title qa__answer_title--active">回答中</div>
          </div>
        </div>


      </div>
      <div class="interview_contents__main">
        <div class="interview_header">
          <div class="interview_header__progress">
            <div class="interview_header__no">
              <div class="interview_header__no_title">
                <img class="interview_header__no_title_icon" src="@/assets/format_list_bulleted.svg" width="24" />回答
              </div>
              <div class="interview_header__no_num">
                Q{{ page.entry?.getQuestionNumber() }}
              </div>
            </div>
            <div class="interview_header__progress_bar"></div>
          </div>
          <div class="interview_header__title" v-if="page.entry != null">
            やりたいことを選んでください（複数選択可）
          </div>
          <div class="interview_header__description" v-if="page.entry != null">
            「{{
              page.entry.getQuestionTitle()
            }}」に関連した質問です。
          </div>

        </div>
        <div class="interview_body">
          <div class="start_interview_expectations__candidates" v-if="page.entry != null">
            <template v-for="(item, index) in page.entry?.getExpectations()" :key="index">
              <h2 v-on:click="page.select(item.id)" :class="[
                isSelected(item.id) ? 'lpbtn--selected' : '',
                index == 0 ? 'lpbtn--first' : '',
              ]" class="lpbtn" style="position: relative; padding-left: 36px">
                {{ item.title }}
                <p class="lpbtn__description" v-if="false"></p>
                <img v-if="!isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20" height="20"
                  src="@/assets/check_outlined.svg" />
                <img v-if="isSelected(item.id)" style="position: absolute; top: 18px; left: 8px" width="20" height="20"
                  src="@/assets/check_filled.svg" />
              </h2>
            </template>
            <h2 class="qasinglebtn" :class="[page.isReset == true ? 'qasinglebtn--selected' : '']"
              v-on:click="page.reset()">なし</h2>
          </div>
          <div class="interview_skip" style="margin-top: 16px">
            <button class="interview_skip__btn" v-on:click="fix()">スキップ</button>
          </div>
        </div>
        <div class="interview_control">
          <button class="interview_control__back btn_outline_primary" v-on:click="back()">
            前の質問に戻る
          </button>
          <button class="interview_control__next btn_primary" v-on:click="select()">
            次へ
          </button>
        </div>
      </div>
      <div class="interview_contents__right"></div>
    </div>
    <div class="qaloading" v-show="true">
      <div class="qaloading__container">
        <div id="lottie"></div>
      </div>
    </div>

    <div style="margin-bottom: 32px; background: rgb(239, 240, 240)" v-if="pager.isDebug">
      <div>デバグ</div>
      <div>やりたいことの複数選択</div>
      <div v-if="page.entry != null">
        <template v-for="(item, index) in page.entry?.getExpectations()" :key="index">
          <div>
            <button v-on:click="page.addExpectation(item.id)">
              {{ item.title }}
            </button>
          </div>
        </template>
      </div>
      <div>選択ID</div>
      <div>
        {{ page.selecteds }}
      </div>
      <div>
        <button v-on:click="fix()" style="background: #00aeaa">次へ</button>
      </div>
      <div v-if="page.entry != null">
        <div>
          <template v-for="(item, index) in page.entry.getHistory()" :key="index">
            <div>
              <div>{{ index + 1 }}</div>
              <div>{{ item.getTitle() }}</div>
              <template v-for="(ritem, rindex) in item.getReplyTitles()" :key="rindex">
                <div>{{ ritem }}</div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
#lottie {
  margin: auto;
  width: 150px;
}
</style>

<style scoped>
.qaloading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
}

.qaloading__container {
  padding-top: 200px;
}
</style>

<style scoped>
.lpbtn {
  background: #f9fbfb;
  color: #444545;
  padding: 18px 18px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  cursor: pointer;
}

.lpbtn--first {
  margin-top: 0px;
}

.lpbtn:hover {
  border: 2px solid #00c9c9;
}

.lpbtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.lpbtn__description {
  font-size: 12px;
  line-height: 126%;
  font-weight: initial;
  min-height: 16px;
}

.qasinglebtn {
  background: #f9fbfb;
  color: #444545;
  padding: 12px 12px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  text-align: left;
  cursor: pointer;
}

.qasinglebtn:hover {
  border: 2px solid #00c9c9;
}

.qasinglebtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}
</style>

<script>
// @ is an alias to /src

import tacklebox from "tacklebox";

import { ExpectationPage } from "@/js/page/ExpectationPage.js";

/* global bodymovin */

tacklebox.d("a");

export default {
  name: "ExpectationView",
  data() {
    const self = this;
    return {
      page: new ExpectationPage(function (msg) {
        if (msg) {
          self.page.fix(function (expectation_cnt) {
            console.log(expectation_cnt);
            self.$router.push({
              name: "interview",
              params: { id: self.page.interviewId },
            });
          });
        }
      }),
      isNetworking: false,
    };
  },
  mounted() {
    this.page.interviewId = this.$route.params.id;
    this.pager.changePage(this.page);

    bodymovin.loadAnimation({
      container: document.getElementById("lottie"),
      renderer: "svg", // 描画形式
      loop: true, // trueにしたらループ。1回再生の場合はfalse
      autoplay: true, // 自動再生
      path: "freeloading.json", // jsonのパスを指定
      name: "Hello World", // 今後のリファレンスとして名前を指定（オプション）
    });

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeUnmount() {
    //
  },
  methods: {
    entrydelete(id) {
      if (window.confirm("回答履歴は消えます")) {
        const self = this;
        console.log(id);
        fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.page.interviewId + "/histories/" + id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          // body: JSON.stringify(rbody)
        })
          .then((response) => response.json())
          .then((json) => {
            console.log(json);
            self.page.loadEntry();
          })
          .catch((error) => {
            tacklebox.e(error)
          });

      }
    },
    select() {
      if (this.page.selecteds.length == 0) {
        this.fix();
      } else {
        this.page.regist();
      }
    },
    getFirstAnswer() {
      let hs = this.page.entry?.getHistory();
      if (hs) {
        if (hs.length > 0) {
          //
          let res = "";
          let csv = "";
          let ts = hs[0].getReplyTitles();
          for (let i in ts) {
            res += csv + ts[i];
            csv = "／";
          }

          return res;
        }
      }
      return "";
    },
    makeAnswerStringByHistory(history) {
      let res = "";
      let csv = "";
      let ts = history.getReplyTitles();
      for (let i in ts) {
        res += csv + ts[i];
        csv = "／";
      }

      return res;
    },
    isSelected(id) {
      for (let i in this.page.selecteds) {
        if (this.page.selecteds[i] == id) {
          return true;
        }
      }
      return false;
    },
    back() {
      // this.$router.push("/");
      let hs = this.page.entry?.getHistory();
      if (hs) {
        if (hs.length == 1) {
          if (hs[0].raw.entry.type == "freeword") {
            if (window.confirm("回答履歴は消えます")) {
              this.$router.push({ name: "freeword" });
              return;
            }
          }
          if (hs[0].raw.entry.type == "category") {
            if (window.confirm("回答履歴は消えます")) {
              console.log(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);
              location.href = this.lpurl(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);
              return;
            }
          }
          if (hs[0].raw.entry.type == "keyword") {
            if (window.confirm("回答履歴は消えます")) {
              console.log(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);
              location.href = this.klpurl(hs[0].raw.entry.category.id, hs[0].raw.entry.category.title);

              return;
            }
          }
        }
      }
      this.page.cencel();
    },
    fix() {
      const self = this;
      this.isNetworking = true;
      this.page.fix(function (expectation_cnt) {
        self.isNetworking = false;
        console.log("expectation_cnt", expectation_cnt);
        if (expectation_cnt > 0) {
          self.$router.push({
            name: "interview",
            params: { id: self.page.interviewId },
          });
        }
      });
    },
    onClose() {
      if (window.confirm("診断を終了してよろしいですか？")) {
        this.$router.push("/");
      }
    },
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
  },
  components: {},
  props: {
    pager: Object,
  },
};
</script>
